import React from "react";

import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { estilos } from "components/utils/mapa/BloqueUbicacion";

import VistaModal from "pages/programa-salud/estructuras/establecimientos/VistaModal";
import { CamposIdentificacionVista } from "pages/programa-salud/estructuras/establecimientos/EstablecimientoVista";

import { ANCHOS_HOSPITAL } from "./CamposHospital";

const Campo = ({ className, name, labelText }) => (
    <FormikTextInput
        className={className}
        name={name}
        labelText={labelText}
        readOnly
    />
);

/**
 * Los campos propios del hospital, arriba del domicilio.
 *
 * Van en dos filas parejas de dos, debajo de nombre y codigo, para que la grilla siga cerrando
 * de a filas completas como en las otras cuatro entidades.
 */
function CamposHospital() {
    return (
        <>
            <CamposIdentificacionVista />
            <Campo
                className={estilos.col6}
                name="nivel"
                labelText="Nivel de Complejidad"
            />
            <Campo className={estilos.col6} name="zona" labelText="Zona" />
            <Campo className={estilos.col6} name="area" labelText="Área" />
            <Campo
                className={estilos.col6}
                name="cabecera"
                labelText="Cabecera"
            />
        </>
    );
}

/**
 * En la consulta los cuatro campos se muestran resueltos a nombre, no al id ni al codigo con
 * el que viajan en el alta: es lo unico que le sirve a quien esta mirando la ficha.
 */
// Recibe la FILA, que ya trae estos cuatro resueltos a texto por la lista —incluida la
// cabecera, que la grilla muestra con las mismas palabras que el formulario—.
const valoresHospital = (row) => ({
    nivel: row.nivel ?? "",
    zona: row.zona ?? "",
    area: row.area ?? "",
    cabecera: row.cabecera ?? "",
});

export default function ViewModal({ row, closeModal }) {
    return (
        <VistaModal
            row={row}
            closeModal={closeModal}
            camposExtra={<CamposHospital />}
            valoresExtra={valoresHospital}
            // El mismo layout que el formulario: la ficha y la edicion del mismo hospital
            // tienen que verse igual.
            mapaAncho={false}
            columnas={ANCHOS_HOSPITAL}
        />
    );
}
